import { Injectable } from '@angular/core';
import { Http, HttpModule , Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { HttpClientService } from 'app/http-client-service/http-client-service.service';
import 'rxjs/Rx';

@Injectable()
export class ServiceStackService {
    SERVICE_STACK_URL: string;
    AUTH_TOKEN: string;

    constructor(private _http: HttpClientService) { }

    Query(entityName, filters, pageInfo) {
        // we have to define this each time because if it's defined outside the auth token is undefined
        
        // stasrt to build params object
        let params = {};
        if (filters) {
            params['RequestFilters'] = filters;
        }
        if (pageInfo) {
            params['PageInfo'] = pageInfo;
        }
        console.info('Service Stack Service: Query - ' + entityName + (filters ? '' : ', with filters: ' + JSON.stringify(filters)));
        console.info(this._http.requestHeaders);
        return this._http.post(
            // pass params through to post
            this.SERVICE_STACK_URL + '/api/' + entityName,
            params
        )
        // map it to a response so we can see it
        .map((response: Response) => response)
        // or catch an error
        .catch(this.handleError);
    };

    GetByOid(entityName, oid) {
        // we have to define this each time because if it's defined outside the auth token is undefined
        console.info('Service Stack Service: GetByOid - ' + entityName + ' Oid: ' + oid);
        return this._http.get(
            this.SERVICE_STACK_URL + '/api/' + entityName + '/' + oid
        )
        .map((response: Response) => response)
        .catch(this.handleError);
    };

    Save(entityName, save) {
        // we have to define this each time because if it's defined outside the auth token is undefined
        let param = { 'Entity': save };
        console.info('Service Stack Service: Save - ' + entityName + ' Saves: ' + JSON.stringify(save));
        return this._http.post(
            this.SERVICE_STACK_URL + '/api/' + entityName,
            param
        )
        .map((response: Response) => response)
        .catch(this.handleError);
    };

    SaveBatch(entityName, saves, filters) {
        // we have to define this each time because if it's defined outside the auth token is undefined
        let params = {};
        if (saves) {
            params["Saves"] = saves
        }
        if (filters) {
            params["FilterFrom"] = {};
            filters.forEach((filter, index) => {
                params["FilterFrom"][index] = filter;
            });
        }
        console.info('Service Stack Service: Save - ' + entityName + ' Saves: ' + JSON.stringify(saves));
        return this._http.post(
            this.SERVICE_STACK_URL + '/api/' + entityName,
            params
        )
        .map((response: Response) => response)
        .catch(this.handleError);
    };

    Delete(entityName, Oid) {
        // we have to define this each time because if it's defined outside the auth token is undefined
        console.info('Service Stack Service: Delete - ' + entityName + ' Oid: ' + Oid);
        return this._http.delete(
            this.SERVICE_STACK_URL + '/api/' + entityName + "/" + Oid
        )
        .map((response: Response) => response)
        .catch(this.handleError);
    };

    //Doesn't work with the server
    /*DeleteByFilter(entityName, filters){
        let params = { action: "deleteByFilter" };
        if (filters) {
            params['RequestFilters'] = filters;
        }

        return this._http.post(
            this.SERVICE_STACK_URL + '/api/' + entityName + "/?action=deleteByFilter",
            params,
            new RequestOptions(this.requestOptions)
        )
        .map((response: Response) => response)
        .catch(this.handleError);
    };*/

    // private method for error handling using an observable
    private handleError(error: Response) {
        console.error('ServiceStackService', 'Server error on ServiceStackService');
        return Observable.throw(error || 'Server error');
    }
   
}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/service-stack-service/service-stack-service.service.ts